import type React from 'react';
import cx from 'clsx';
import Styles from '../list/ConstructionList.module.scss';
import type { DealEstimationHistoryContext } from '~/models/DealEstimationHistory';
import { ConstructionListRow } from './ConstructionListRow';

type Props = {
  constructionContext: DealEstimationHistoryContext;
  companyType: 'client' | 'vendor' | 'partner';
};
export const ConstructionConfirmedList: React.FC<Props> = ({
  constructionContext,
  companyType
}: Props) => (
  <div>
    <table className={Styles.List}>
      <thead>
        <tr className={cx(Styles.ListRow, Styles.Header)}>
          <th />
          <th className={Styles.Estimation}>施工項目</th>
          <th className={Styles.UnitAmount}>単価 * 数量</th>
          <th className={Styles.ChargePer}>負担割合</th>
          <th className={Styles.Amount}>価格</th>
        </tr>
      </thead>
      <tbody>
        <ConstructionListRow
          companyType={companyType}
          constructionContext={constructionContext}
        />
      </tbody>
    </table>
  </div>
);
